import React from 'react';

import styles from './GoodsCardSkeleton.module.css';

const GoodsCardSkeleton = () => {
  return (
    <div className={`goods-card ${styles.skeletonCard}`}>
      <div className={`${styles.skeleton} ${styles.skeletonImage}`} />
      <div className={`${styles.skeleton} ${styles.skeletonTitle}`} />
      <div className={`${styles.skeleton} ${styles.skeletonSubtitle}`} />
      <div className={`${styles.skeleton} ${styles.skeletonTag}`} />
      <div className={`${styles.skeleton} ${styles.skeletonPrice}`} />
    </div>
  );
};

export default GoodsCardSkeleton;
